import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';


@Injectable()
export class AuthHandlerService {
    //subject with return url as data
    public notAuthorizedSubject: Subject<string> = new Subject();
}
